import { computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { UserService } from '../../features/user-management/services/user.service';
import { PermissionService } from '../services/permission.service';

export const userManagementGuard: CanActivateFn = () => {
  const permissionService = inject(PermissionService);
  const userService = inject(UserService);
  const router = inject(Router);

  const accessReady = computed(
    () =>
      !!userService.realm() &&
      !!userService.accessToken() &&
      !userService.isMeLoading(),
  );

  return toObservable(accessReady).pipe(
    filter((ready) => ready),
    take(1),
    map(() =>
      permissionService.canAccessUserManagement()
        ? true
        : router.createUrlTree(['/unauthorized-access']),
    ),
  );
};
